import { render } from "./ConfirmTripRecordItem.vue?vue&type=template&id=c8588536&scoped=true"
import script from "./ConfirmTripRecordItem.vue?vue&type=script&lang=ts"
export * from "./ConfirmTripRecordItem.vue?vue&type=script&lang=ts"

import "./ConfirmTripRecordItem.vue?vue&type=style&index=0&id=c8588536&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-c8588536"

export default script